import { schema } from "normalizr";

const TagSchema = new schema.Entity("tags");
const TagArraySchema = new schema.Array(TagSchema);

export { TagSchema, TagArraySchema };